
    
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { PathwayPage } from "@/model/PathwayPage";

    @Component({})
    export default class PagePart extends Vue {

        @Prop({ default: false}) 
        private value!: boolean;

        @Prop({ required: true })
        pathwayPage!: PathwayPage;

        onClick() {
            this.$emit("input", !this.value); // input event to implement v-model

            // we also want to let the parent know *exactly* what changed so we can fire off an API save
            // (a watcher in the parent is not really up to it 'cos array)
            this.$emit("selected-changed", this.pathwayPage);
        }

        get icon(): string {
            return this.value ? "mdi-checkbox-marked-circle-outline" : "mdi-circle-outline" ;
        }
    }
